'use client'

import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { AnchorHTMLAttributes, MouseEventHandler, useState } from 'react'

export function CopyLink({ children, ...rest }: React.PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>) {
    const [isOpen, setIsOpen] = useState(false)

    const onLinkClick: MouseEventHandler<HTMLAnchorElement> = async (e) => {
        e.preventDefault()

        try {
            if (!rest.href) {
                throw 'No link to copy'
            }

            navigator.clipboard.writeText(rest.href)
            setIsOpen(true)
            setTimeout(() => setIsOpen(false), 1200)
        } catch (_) {
            // Failed to copy, nothing to see here
            // Possibly warn users, but they should expect this if permissions were denied
        }
    }
    return (
        <TooltipProvider>
            <Tooltip open={isOpen}>
                <TooltipTrigger asChild>
                    <a onClick={onLinkClick} {...rest}>
                        {children}
                    </a>
                </TooltipTrigger>
                <TooltipContent
                    className='data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-violet11 select-none rounded-md bg-white px-4 py-2.5 text-sm leading-none shadow-md will-change-[transform,opacity] border border-gray-200 text-black'
                    sideOffset={5}
                >
                    Link Copied!
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
